import Vue from 'vue';
import 'vuetify/dist/vuetify.css';
import './custom.scss';
import './common.scss';
import './responsive.scss';
import 'vue-select/src/scss/vue-select.scss';
import 'vue-select/dist/vue-select.css';
import Vuetify from 'vuetify/lib/framework';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import vi from 'vuetify/src/locale/vi';
import en from 'vuetify/src/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { vi, en },
        current: 'vi',
    },
    icons: {
        iconfont: 'mdiSvg',
    },
});
